import { deleteChannelRule } from '../../services/api/channelRule.api';
import { DELETE_CHANNEL_RULE_REQUEST, DELETE_CHANNEL_RULE_SUCCESS, DELETE_CHANNEL_RULE_FAILURE } from '../types';
import { transformError } from '../../transforms/error';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
	},

	mutations: {
		[DELETE_CHANNEL_RULE_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
		},
		[DELETE_CHANNEL_RULE_SUCCESS](state) {
			state.isLoading = false;
		},
		[DELETE_CHANNEL_RULE_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async removeChannelRule({ commit }, id) {
			try {
				commit(DELETE_CHANNEL_RULE_REQUEST);
				await deleteChannelRule(id);
				commit(DELETE_CHANNEL_RULE_SUCCESS);
			} catch (error) {
				commit(DELETE_CHANNEL_RULE_FAILURE, error);
			}
		},
	},
};